import React, { useState } from 'react';
import { storeLocation, getUserLocation } from '../../utils/location';
import './LocationModal.css';

const CITIES = [
  { name: 'Pune', icon: '🏙️', active: true },
  { name: 'Mumbai', icon: '🌆', active: false },
  { name: 'Delhi', icon: '🏛️', active: false },
  { name: 'Bangalore', icon: '🌿', active: false },
  { name: 'Hyderabad', icon: '🕌', active: false },
  { name: 'Chennai', icon: '🌊', active: false },
  { name: 'Kolkata', icon: '🌉', active: false },
  { name: 'Nagpur', icon: '🍊', active: false },
];

const LocationModal = ({ onClose }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [detecting, setDetecting] = useState(false);
  const [detectError, setDetectError] = useState('');
  const [comingSoonCity, setComingSoonCity] = useState(null);

  const filteredCities = CITIES.filter((c) =>
    c.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleCityClick = (city) => {
    if (city.active) {
      storeLocation({ city: city.name });
      onClose();
    } else {
      setComingSoonCity(city.name);
    }
  };

  const handleDetectLocation = async () => {
    setDetecting(true);
    setDetectError('');
    try {
      const location = await getUserLocation();
      storeLocation(location);
      onClose();
    } catch {
      setDetectError('Could not detect location. Please select a city manually.');
      setDetecting(false);
    }
  };

  return (
    <div className="lm-overlay">
      <div className="lm-card">
        {comingSoonCity ? (
          <div className="lm-coming-soon">
            <div className="lm-cs-rocket">🚀</div>
            <h2>Coming Soon!</h2>
            <p className="lm-cs-city">
              We're expanding to <strong>{comingSoonCity}</strong>
            </p>
            <p className="lm-cs-sub">
              Stay tuned — amazing furniture rental deals are heading your way!
            </p>
            <button
              className="lm-back-btn"
              onClick={() => setComingSoonCity(null)}
            >
              ← Back to Cities
            </button>
          </div>
        ) : (
          <>
            <div className="lm-header">
              <div className="lm-pin-icon">📍</div>
              <h2 className="lm-title">Select Your City</h2>
              <p className="lm-subtitle">
                Find the best furniture rental deals near you
              </p>
            </div>

            <button
              className="lm-detect-btn"
              onClick={handleDetectLocation}
              disabled={detecting}
            >
              {detecting ? (
                <>
                  <span className="lm-btn-spinner" />
                  Detecting your location…
                </>
              ) : (
                <>
                  <span className="lm-detect-icon">🎯</span>
                  Use my current location
                </>
              )}
            </button>

            {detectError && (
              <p className="lm-detect-error">{detectError}</p>
            )}

            <div className="lm-divider">
              <span>or choose a city</span>
            </div>

            <div className="lm-search-wrap">
              <span className="lm-search-icon">🔍</span>
              <input
                type="text"
                className="lm-search-input"
                placeholder="Search city…"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="lm-cities-grid">
              {filteredCities.map((city) => (
                <button
                  key={city.name}
                  className={`lm-city-btn ${city.active ? 'lm-city-active' : 'lm-city-soon'}`}
                  onClick={() => handleCityClick(city)}
                >
                  <span className="lm-city-emoji">{city.icon}</span>
                  <span className="lm-city-name">{city.name}</span>
                  {!city.active && (
                    <span className="lm-soon-badge">Coming Soon</span>
                  )}
                </button>
              ))}
              {filteredCities.length === 0 && (
                <p className="lm-no-result">No city found for "{searchQuery}"</p>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default LocationModal;
